<!--
 * @Date: 2020-05-15 12:54:32
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-29 10:18:47
 * @FilePath: /xy-pc/src/views/userCenter/mymessage/list.vue
--> 
<template>
  <div class="activePain" style="width:100%">
    <el-tabs v-model="activeName" style="min-height:400px">
      <el-tab-pane label="我的消息" name="first">
        <div
          class="contant_list"
          v-for="(item,index) in messageList"
          :key="index"
          @click="$router.push({path:'/messageDetail',query:{id:item.id}})"
        >
          <div class="list-left">
            <div class="contant_opacity"></div>
            <img class="contant_img" src="../../../assets/icons/buy.svg" alt />
          </div>
          <div class="list-right">
            <div class="contant_text3 ellipsis-1">{{item.content}}</div>
            <div class="contant_text2">{{item.created_at}}</div>
          </div>
        </div>
        <div v-if="messageList.length==0">
          <el-card>
            <p style="text-align:center;margin-top:130px;margin-bottom:100px">暂无消息通知 !</p>
          </el-card>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div style="margin:20px 0 40px;text-align: center;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="limit"
        layout=" sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "student_message",

  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      activeName: "first",
      messageList: []
    };
  },

  created() {},
  activated() {
    this.getMessageList();
  },

  methods: {
    getMessageList() {
      this.$http({
        url: "api/v1/auth/messages",
        method: "get",
        params: { page: this.page, limit: this.limit }
      }).then(res => {
        if (res.status == 200) {
          this.messageList = res.data.messages;
          if (res.data.total) {
            this.total = res.data.total;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getMessageList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getMessageList();
    }
  }
};
</script>

<style lang="less" scoped>
.contant_list {
  margin-top: 15px;
  height: 85px;
  cursor: pointer;
}
.contant_text3:hover {
  cursor: pointer;
  color: rgba(51, 119, 255, 1) !important;
}
.contant_opacity {
  width: 63px;
  height: 63px;
  left: 586px;
  top: 357px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(42, 130, 228, 0.15);
  border-radius: 32px;
  font-size: 15px;
  line-height: 150%;
  text-align: center;
}
.list-left {
  float: left;
  height: 63px;
  margin-right: 14px;
}
.list-right {
  float: left;
}
.contant_img {
  width: 32px;
  height: 32px;
  left: 16px;
  top: -48px;
  font-size: 32px;
  color: #2a82e4;
  position: relative;
}

.contant_text2 {
  height: 29px;
  color: #999;
  font-size: 13px;
  line-height: 29px;
  text-align: left;
}
.contant_text3 {
  width: 791px;
  height: 34px;
  color: #999;
  font-size: 14px;
  line-height: 34px;
  text-align: left;
}
</style>